export default __webpack_public_path__ + "static/moncofa-9692d47c77a874ee1e83476375364e1c.jpg";